import React, { useState } from 'react';
import './CallHistory.css';

const CallHistory = ({ callHistory }) => {
  const [selectedCall, setSelectedCall] = useState(null);

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return '#10b981';
      case 'failed':
        return '#ef4444';
      case 'in-progress':
        return '#f59e0b';
      default:
        return '#6b7280';
    }
  };

  const closeModal = () => {
    setSelectedCall(null);
  };

  return (
    <div className="call-history">
      <h3>Call History</h3>
      
      {callHistory.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📞</div>
          <h4>No calls yet</h4>
          <p>Your AI call history will appear here after you make your first quote request.</p>
        </div>
      ) : (
        <div className="history-list">
          {callHistory.map((call) => (
            <div key={call.id} className="history-item">
              <div className="item-header">
                <div className="business-info">
                  <h4>{call.businessName}</h4>
                  <p>{call.serviceType}</p>
                </div>
                <div className="call-status">
                  <span 
                    className="status-badge"
                    style={{ backgroundColor: getStatusColor(call.status) }}
                  >
                    {call.status}
                  </span>
                  <span className="call-time">{formatDate(call.timestamp)}</span>
                </div>
              </div>
              
              <div className="item-summary">
                <p><strong>Phone:</strong> {call.businessPhone}</p>
                {call.originalPrompt && (
                  <p><strong>Request:</strong> {call.originalPrompt.substring(0, 100)}{call.originalPrompt.length > 100 ? '...' : ''}</p>
                )}
                <p><strong>Outcome:</strong> {call.outcome}</p>
                {call.quote && (
                  <p><strong>Quote Range:</strong> {call.quote.estimateRange}</p>
                )}
              </div>
              
              <div className="item-actions">
                <button 
                  className="btn btn-small btn-outline"
                  onClick={() => setSelectedCall(call)}
                >
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {selectedCall && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Call Details</h3>
              <button className="close-button" onClick={closeModal}>&times;</button>
            </div>
            
            <div className="modal-body">
              <div className="call-details">
                {selectedCall.originalPrompt && (
                  <div className="detail-section">
                    <h4>Original Request</h4>
                    <div className="original-prompt">
                      {selectedCall.originalPrompt}
                    </div>
                  </div>
                )}

                <div className="detail-section">
                  <h4>Business Information</h4>
                  <p><strong>Name:</strong> {selectedCall.businessName}</p>
                  <p><strong>Phone:</strong> {selectedCall.businessPhone}</p>
                  <p><strong>Service Type:</strong> {selectedCall.serviceType}</p>
                  <p><strong>Status:</strong> 
                    <span 
                      className="status-badge"
                      style={{ backgroundColor: getStatusColor(selectedCall.status), marginLeft: '8px' }}
                    >
                      {selectedCall.status}
                    </span>
                  </p>
                  <p><strong>Call Time:</strong> {formatDate(selectedCall.timestamp)}</p>
                </div>

                <div className="detail-section">
                  <h4>Call Outcome</h4>
                  <p>{selectedCall.outcome}</p>
                </div>

                {selectedCall.quote && (
                  <div className="detail-section">
                    <h4>Quote Information</h4>
                    <p><strong>Estimate Range:</strong> {selectedCall.quote.estimateRange}</p>
                    {selectedCall.quote.estimateFee && (
                      <p><strong>Estimate Fee:</strong> {selectedCall.quote.estimateFee}</p>
                    )}
                    {selectedCall.quote.appointmentScheduled && (
                      <p><strong>Appointment:</strong> {selectedCall.quote.appointmentScheduled}</p>
                    )}
                    {selectedCall.quote.followUpMethod && (
                      <p><strong>Follow-up:</strong> {selectedCall.quote.followUpMethod}</p>
                    )}
                  </div>
                )}

                {selectedCall.transcript && selectedCall.transcript.length > 0 && (
                  <div className="detail-section">
                    <h4>Call Transcript</h4>
                    <div className="transcript-detail">
                      {selectedCall.transcript.map((entry, index) => (
                        <div key={index} className={`transcript-entry ${entry.speaker.toLowerCase().replace(' ', '-')}`}>
                          <div className="speaker-info">
                            <span className="speaker-name">{entry.speaker}</span>
                            {entry.timestamp && <span className="timestamp">{entry.timestamp}</span>}
                          </div>
                          <div className="message">{entry.message}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CallHistory;